module.exports = __webpack_public_path__ + "static/media/(000104).f02069a5.jpg";